import { Routes } from '@angular/router';
import { GlobalRoutingGuard } from '../guards/global-routing.guard';
import { HomeComponent } from '../pages/home/home.component';
import { authModuleBaseRoute } from './api-authorization-routes';
import { userModuleBaseRoute } from './user-routes';
import { invoiceModuleBaseRoute } from './invoice-routes';
import { MyGarageComponent } from '../pages/my-garage/my-garage.component';
import { PermissionGuard } from '../guards/permission.guard';
import { VehicleDetailComponent } from '../pages/vehicle-detail/vehicle-detail.component';
import { RegistrationConfirmationComponent } from '../pages/registration-confirmation/registration-confirmation.component';
import { ContactUsComponent } from '../pages/contact-us/contact-us.component';
import { VehicleDropOffComponent } from '../pages/vehicle-drop-off/vehicle-drop-off.component';

export const appModuleBaseRoute = '';

export const appModuleRoutes = {
};

export const ParentRoutes: Routes = [
    {
    path: appModuleBaseRoute,
    canActivateChild: [GlobalRoutingGuard],
    children: [
        { path: appModuleBaseRoute, component: HomeComponent, pathMatch: 'full' },
        {
            path: authModuleBaseRoute,
            loadChildren: () => import('./api-authorization-routes').then( r => r.AUTH_ROUTES )
        },
        {
            path: userModuleBaseRoute,
            loadChildren: () => import('./user-routes').then( r => r.USER_ROUTES )
        },
        {
            path: invoiceModuleBaseRoute,
            loadChildren: () => import('./invoice-routes').then( r => r.INVOICE_ROUTES )
        },
        {
            path: 'registration-confirmation',
            component: RegistrationConfirmationComponent
        },
        {
            path: 'contact-us',
            component: ContactUsComponent
        },
        {
            // Public QR-code target — intentionally unguarded.
            path: 'vehicle-drop-off',
            component: VehicleDropOffComponent
        },
        {
            path: 'my-garage',
            component: MyGarageComponent,
            canActivate: [PermissionGuard],
            data: { requireOneOf: ['VIEW_GARAGE', 'VIEW_ALL_GARAGES']}
        },
        {
            path: 'my-garage/:vehicleId',
            component: VehicleDetailComponent,
            canActivate: [PermissionGuard],
            data: { requireOneOf: ['VIEW_GARAGE', 'VIEW_ALL_GARAGES']}
        }
    ]
    },
]
